import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, PUT } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// AppSetUp - Get All (Read)
export const GetAll = createAsyncThunk(
  "HelpSection/privacypolicy/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.HelpSection.PrivacyPolicy}?email=${filter?.email ||
          ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page ||
          IDS.PERPAGE}`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// AppSetUp - Get (Read)
export const GetSingle = createAsyncThunk(
  "HelpSection/privacypolicy/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.HelpSection.PrivacyPolicy}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// AppSetUp - Update
export const Update = createAsyncThunk(
  "HelpSection/privacypolicy/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(
        `${APIS.HelpSection.PrivacyPolicy}/${id}`,
        data
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "privacypolicy",
  initialState: {
    data: null, // Store single record
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // GetAll
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // GetSingle
      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data; // Store single record
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Update
      .addCase(Update.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data; // Update with new record
      })
      .addCase(Update.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default Slice.reducer;
